import React from "react";
import { Card } from "../card";
import { ListTable } from "../Table/listTable/listTable";
import { teachersListTitle } from "../../Constants/tableTitles/ListTableTitle/teacherList.titles";
import { useListTeacher } from "../../hooks/teacherHooks/teacher.hooks";
import { transformTeacherListTableData } from "../../Services/transformer/transformTeacherListTabelData";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../Constants/paths";
import { TeacherNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";

export const ListTeachers = () => {
  const navigate = useNavigate();
  const { isLoading: isTeachersListLoading, data } = useListTeacher();

  const teachersList = data?.result || [];
  const lastPage = data?.lastPage;

  return (
    <Card>
      <ListTable
        titles={teachersListTitle}
        data={teachersList}
        isDataLoading={isTeachersListLoading}
        transformFn={transformTeacherListTableData}
        pagination={{
          onPageChange: (pageNo) => {},
          totalPage: lastPage,
        }}
        onRowClick={(data: any) => {
          navigate(
            `${Paths.TeacherDetail}?section=${TeacherNavigationHeader.TEACHER_INFO}&teacherId=${data.id}`
          );
        }}
      />
    </Card>
  );
};
